function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 2H8.99997C7.89697 2 6.99997 2.897 6.99997 4V9.586L2.29297 14.293C2.15316 14.4329 2.05795 14.611 2.01939 14.805C1.98082 14.9989 2.00062 15.2 2.07629 15.3827C2.15196 15.5654 2.2801 15.7215 2.44451 15.8314C2.60892 15.9413 2.80222 16 2.99997 16V21C2.99997 21.2652 3.10533 21.5196 3.29286 21.7071C3.4804 21.8946 3.73475 22 3.99997 22H20C20.2652 22 20.5195 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V4C21 2.897 20.103 2 19 2ZM11 20H4.99997V14.414L7.99997 11.414L11 14.414V20ZM19 20H13V16C13.1979 16.0004 13.3916 15.942 13.5563 15.8322C13.721 15.7224 13.8494 15.5662 13.9251 15.3833C14.0009 15.2004 14.0206 14.9991 13.9818 14.805C13.9429 14.6109 13.8473 14.4327 13.707 14.293L8.99997 9.586V4H19V20Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 6H13V8H11V6ZM15 6H17V8H15V6ZM15 10.031H17V12H15V10.031ZM15 14H17V16H15V14ZM7 15H9V17H7V15Z",
  fill: "current"
});

var SvgBuildingIcon = function SvgBuildingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuildingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building-icon.3dd1b5a2.svg";
export { ForwardRef as ReactComponent };